"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createHydrator;

var _destructure = _interopRequireDefault(require("./destructure"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var HYDRATE = 'sa.rdx.hydrate';

function createHydrator(structure, save) {
  var saving = null;

  function triggerStorage(newState) {
    if (saving) {
      saving = newState;
      return;
    }

    saving = newState; // Perform a save after few milliseconds to avoid consecutive save requests

    setTimeout(function () {
      save(saving);
      saving = null;
    }, 100);
  }

  return {
    enhanceReducer: function enhanceReducer(reducer) {
      return function (state, action) {
        if (action.type === HYDRATE) {
          triggerStorage(action.payload);
          return action.payload;
        }

        var newState = reducer(state, action);

        if (state !== newState) {
          // Save state to persistent storage
          triggerStorage(newState);
        }

        return newState;
      };
    },
    hydrate: function hydrate(store, state) {
      var newState = (0, _destructure["default"])(structure, function (item, key) {
        var stateByKey = state[key];
        return item.onRestore(stateByKey);
      });
      store.dispatch({
        type: HYDRATE,
        payload: newState
      });
    }
  };
}